import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { connect } from 'react-redux';
import firebase from 'firebase/app';
import 'firebase/database';
import { authManager, userManager, publisherManager } from '../../helpers/managers';
import Axios from 'axios';
import has from 'lodash/has';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import getPath from 'lodash/get';
import Dots from 'react-activity/lib/Dots';
import styled from 'styled-components';
import {
  addUpdateManagedSoundcastEpisode,
  increasePlanCurrentUsage,
  decreasePlanCurrentUsage,
  removeSoundcastPendingInvites,
  fetchCategories,
  createPublisherCategory,
  updateSoundcastsPublisherCategory,
  updatePublisherCategoryOrder,
  deletePublisherCategory,
} from '../../actions';
import {
  fetchManagedSoundcastEpisodesCreator,
  updateSoundcastEpisodesOrderCreator,
  deleteManagedSoundcastEpisodesCreator,
  bulkActionEpisodesCreator,
  fetchPublisherPlanUsageCreator,
  updateManagedSoundcastsOrderCreator,
  updateManagedBundlesOrderCreator,
  updateManagedBundleSouncastsOrderCreator,
  fetchManagedSoundcastsOrderCreator,
  fetchManagedBundlesOrderCreator,
  fetchManagedBundleSoundcastsOrderCreator,
} from '../../routines';
import { SoundwiseHeader } from '../../components/soundwise_header';
import CreateEditEpisode from './components/episode/CreateEditEpisode';
import SoundcastsManaged from './components/managed';
import Categories from './components/categories';
import SoundcastEpisodes from './components/managed/SoundcastEpisodes';
import CreateSoundcast from './components/soundcast/create_soundcast';
import EditSoundcast from './components/soundcast/edit_soundcast';
import CreateEditBundle from './components/create_edit_bundle';
import Subscribers from './components/subscribers';
import Subscriber from './components/subscriber';
import Announcements from './components/announcements';
import Analytics from './components/analytics';
import Publisher from './components/publisher';
import Ratings from './components/ratings';
import { isUserSessionHasFacebookAuth, getUserSessionIdtoken } from '../../helpers/userSession';
import { canUserAccessFeature, getSoundcastsManaged } from '../../helpers/userinfoHelper';
import { delay } from '../../helpers/misc';
import userTour from '../../helpers/tour';
import Colors from '../../styles/colors';
import Loading from '../../components/Loading';
import { FullContentWrapper, FullContentSection, LoadingWrapper } from '../../styles/styled';
import { updateSoundcastsCategoryTitle } from '../../actions/index';
import {
  clearTagAsFeaturedCreator,
  updateTagAsFeaturedCreator,
} from '../../routines/publisher';

const verticalMenuItems = [
  {
    path: 'soundcasts',
    label: 'Soundcasts',
    iconClass: 'headset',
    isMenuItemVisible: true,
    Component: SoundcastsManaged,
  },
  {
    path: 'edit',
    label: 'edit',
    isMenuItemVisible: false,
    Component: EditSoundcast,
  },
  {
    path: 'soundcast',
    label: 'edit',
    isMenuItemVisible: false,
    Component: SoundcastEpisodes,
  },
  {
    path: 'add_episode',
    label: 'Add Track',
    iconClass: 'settings_voice',
    isMenuItemVisible: true,
    Component: CreateEditEpisode,
  },
  {
    path: 'add_soundcast',
    isMenuItemVisible: false,
    Component: CreateSoundcast,
  },
  {
    path: 'create_bundle',
    isMenuItemVisible: false,
    Component: CreateEditBundle,
  },
  {
    path: 'edit_bundle',
    isMenuItemVisible: false,
    params: { editmode: true },
    Component: CreateEditBundle,
  },
  {
    path: 'analytics',
    label: 'Analytics',
    access: 'VIEW_ANALYTICS',
    iconClass: 'assessment',
    isMenuItemVisible: true,
    Component: Analytics,
  },
  {
    path: 'subscribers',
    label: 'Listeners',
    access: 'VIEW_SUBSCRIBERS',
    iconClass: 'people',
    isMenuItemVisible: true,
    Component: Subscribers,
  },
  {
    path: 'subscriber',
    isMenuItemVisible: false,
    Component: Subscriber,
  },
  {
    path: 'categories',
    iconClass: 'list',
    label: 'Categories',
    isMenuItemVisible: true,
    Component: Categories,
  },
  {
    path: 'ratings',
    label: 'Ratings',
    iconClass: 'stars',
    isMenuItemVisible: true,
    Component: Ratings,
  },
  {
    path: 'messages',
    label: 'Messages',
    access: 'VIEW_MESSAGES',
    iconClass: 'message',
    isMenuItemVisible: true,
    Component: Announcements,
  },
  {
    path: 'publisher',
    label: 'Publisher',
    iconClass: 'work',
    isMenuItemVisible: true,
    Component: Publisher,
  },
  {
    path: 'edit_episode',
    label: 'edit_track',
    isMenuItemVisible: false,
    params: { editmode: true },
    Component: CreateEditEpisode,
  }
];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedVerified: JSON.parse(localStorage.getItem('feedVerified')),
      loading: true,
      loadingMsg: 'Loading Dashboard',
    };

    this.handlePublisherProps = this.handlePublisherProps.bind(this);
    this.navigateToTabSection = this.navigateToTabSection.bind(this);
  }

  navigateToTabSection(path) {
    const { userInfo } = this.props;
    const { publisher = {} } = userInfo;
    if (!isEmpty(publisher)) {
      const soundcastsManaged = getSoundcastsManaged(userInfo);
      if (isEmpty(soundcastsManaged)) {
        return alert('Please create a new soundcast first');
      }

      // allow
      this.props.history.push(path);
    }
  }

  componentDidMount() {
    // if coming path request from index
    // redirect to real dashboard path
    const { fromindex = false, history, match = {} } = this.props;
    if (fromindex) {
      return (window.location.href = `/dashboard/soundcasts`);
    }

    const isHasTab = has(match, 'params.tab');
    const paramsTab = match.params.tab;
    if (!isHasTab || isEmpty(paramsTab)) {
      return history.push('/dashboard/soundcasts');
    }
    const currentTab = find(verticalMenuItems, { path: paramsTab });
    if (isEmpty(currentTab)) {
      return history.push('/notfound');
    }

    authManager.onAuthStateChanged(user => {
      if (!user) {
        return this.props.history.push('/signin');
      }

      this.handlePublisherProps();
    });
  }

  componentDidUpdate(prevProps) {
    const { userInfo, isLoggedIn } = this.props;
    if (!isLoggedIn) {
      window.location.href = '/signin';
      return;
    }

    if (!userInfo.admin) {
      window.location.href = '/mysoundcasts';
      return;
    }

    // if userId and publisher is available, execute the prop checker
    // which is exclusive for publisher accounts
    const { userInfo: prevUserInfo = {} } = prevProps;
    const isPublisherReady = isEmpty(prevUserInfo.publisher) && !isEmpty(userInfo.publisher);
    if (!isEmpty(userInfo) && isPublisherReady) {
      this.handlePublisherProps();
    }
  }

  async forceEpisodesTransition(token) {
    const { userInfo } = this.props;
    const { id: userId, publisher } = userInfo;
    const { id: publisherId, soundcasts = {} } = publisher;

    // remove transition from user object (old version)
    if (!isEmpty(userInfo.transition)) {
      await userManager.removeProp(userId, 'transition');
    }

    // if the publisher has no soundcasts, then nothing to transition
    if (isEmpty(soundcasts)) {
      console.log('Nothing to transition');
      return this.setState({ loading: false });
    }

    // read transition from publisher (new version)
    const transition = getPath(publisher, 'transition.episodes', 'unset');
    const identifyTransition = transition => expected => isEqual(transition, expected);
    const isStatus = identifyTransition(transition);

    // if already transitioned do nothing
    if (isStatus('done')) {
      console.log('Already transitioned', transition);
      return this.setState({ loading: false });
    }

    // call the transition api on certain status only
    // such as unset or failed
    if (isStatus('unset') || isStatus('failed')) {
      // if its a failed transition before, remove the node first
      if (isStatus('failed')) {
        await publisherManager.removeProp(publisherId, 'transition');
      }

      console.log('Calling API', transition);
      await Axios.post(`/api/user/${userId}/transition/episodes`, null, {
        headers: { token },
      });
    }

    // aside from done, we should listen to the transition node
    const transitionRef = firebase.database().ref(`publishers/${publisherId}/transition`);
    transitionRef.on('value', snapshot => {
      if (!snapshot.exists()) return;

      console.log('transitioning data', snapshot.val());
      const { episodes: transitionStatus, episodes_progress = 0 } = snapshot.val();
      const isNewStatus = identifyTransition(transitionStatus);
      const progress = isNewStatus('done') ? 100 : episodes_progress;
      const loadingMsg = `Verifying soundcasts and tracks (${progress}%)`;
      this.setState({ loading: true, loadingMsg }, async () => {
        if (isNewStatus('done')) {
          transitionRef.off('value');
          await delay(2000);
          this.setState({ loading: false });
        }

        if (isNewStatus('failed')) {
          transitionRef.off('value');
          this.setState({
            loadingMsg: 'Verification of data failed, please contact support.',
          });
        }
      });
    });
  }

  runOnboardingTour() {
    const { userInfo } = this.props;
    const { withTour = false } = userInfo;
    if (!withTour) return;

    // identify this user for the tour
    userTour.initUser(userInfo);
  }

  getPlanUsage(token) {
    return this.props.fetchPublisherPlanUsageCreator({ token });
  }

  async handlePublisherProps() {
    const { userInfo, history } = this.props;
    const { publisherID, id: userId, publisher } = userInfo;
    const { feedVerified } = this.state;

    // only when if userId and publisher is available
    if (isEmpty(userInfo) && isEmpty(userInfo.publisher)) {
      return;
    }

    console.log('handlePublisherProps', userId, publisher);

    // Feed request
    if (!this.parseFeedRequestLock && feedVerified && publisherID && userId) {
      this.parseFeedRequestLock = true;
      console.log('Running parse_feed request', feedVerified);
      Axios.post('/api/parse_feed', {
        feedUrl: feedVerified.feedUrl,
        userId,
        publisherId: publisherID,
        importFeedUrl: true, // run import or claim
      })
        .then(() => {
          // if (res.data === 'Success_import' || res.data === 'Success_claim') {
          this.setState({ feedVerified: null });
          localStorage.removeItem('feedVerified'); // unset feed object
          // }
        })
        .catch(err => {
          console.log('import feed request failed', err, err && err.response && err.response.data);
          alert('Hmm...there is a problem importing feed. Please try again later.');
          this.setState({ feedVerified: null });
          localStorage.removeItem('feedVerified'); // unset feed object
        });
    }

    // below request the user id to exist
    if (isEmpty(userId)) {
      return false;
    }

    // Facebook auth transition
    if (!this.facebookTransitionLock) {
      this.facebookTransitionLock = true;
      const user = authManager.getCurrentUser();
      const hasFacebookAuth = await isUserSessionHasFacebookAuth(user);
      if (hasFacebookAuth) {
        const transitionUser = { ...userInfo };
        history.replace('/signin/transition', { transitionUser });
      }
    }

    // below request the publisher object to exist
    if (isEmpty(publisher)) {
      return false;
    }

    // check the publisher prop for `owner` to identify the owner of the publisher
    const token = await getUserSessionIdtoken();
    console.log(token);
    if (!this.ownerIdentificationLock) {
      this.ownerIdentificationLock = true;
      if (!('owner' in publisher)) {
        // identify the owner of this publisher based on administrators registration date
        try {
          await Axios.post(`/api/publishers/owner`, null, {
            headers: { token },
          });
        } catch (err) {
          console.log('Unable to identify owner from admins', err.message);
        }
      }
    }

    // get plan usage
    await this.getPlanUsage(token);

    // firebase episodes transition to postgre
    // do a force transition if possible
    this.forceEpisodesTransition(token);

    // run onboarding tours, only for new users
    this.runOnboardingTour();
  }

  hasAccessToFeature(section) {
    if (!('access' in section)) {
      return true;
    }

    return canUserAccessFeature(section.access);
  }

  render() {
    const { loading, loadingMsg } = this.state;
    const { userInfo, history, match = {}, isLoggedIn } = this.props;

    if (!isLoggedIn || loading) {
      return (
        <FullContentWrapper>
          <FullContentSection>
            <LoadingWrapper>
              <Loading text={loadingMsg} align="center" size={50} fontSize={1.8} />
            </LoadingWrapper>
          </FullContentSection>
        </FullContentWrapper>
      );
    }

    const { feedVerified } = this.state;
    const currentTab = has(match, 'params.tab')
      ? find(verticalMenuItems, { path: match.params.tab })
      : {};
    const extraparams = !isEmpty(currentTab) && 'params' in currentTab ? currentTab.params : {};

    return (
      <FullContentWrapper>
        <SoundwiseHeader showIcon={true} />
        {feedVerified && (
          <div className="importing-feed-overlay">
            <div>Importing feed... Please wait</div>
            <div style={{ marginTop: 20 }}>
              <Dots style={{}} color={Colors.mainOrange} size={22} speed={1} />
            </div>
          </div>
        )}
        <DashboardSection className="row">
          <VerticalMenu className="col-lg-2 col-md-3 col-sm-3 col-xs-2 xs-width-70px xs-pull-left">
            {verticalMenuItems.map((item, i) => {
              if (!item.isMenuItemVisible) {
                return null;
              }

              const isTabActive =
                match.params.tab === item.path || item.path.includes(match.params.tab);
              return (
                <div className="row" key={`vmenu-${i}`}>
                  <div
                    className="col-lg-12"
                    style={{ backgroundColor: isTabActive ? '#f5f5f5' : '#fff' }}>
                    <VerticalMenuItem
                      className="xs-padding-left-15px xs-padding-right-15px xs-padding-top-20px xs-padding-bottom-20px"
                      active={isTabActive}
                      key={`verticalKey${i}`}
                      id={item.path === 'add_episode' ? 'dashboardMenuAddEpisodeTestBtn' : ''}
                      onClick={() => {
                        if (match.params.tab !== item.path) {
                          const sections = [
                            'add_episode',
                            'analytics',
                            'subscribers',
                            'messages',
                            'ratings',
                          ];
                          if (sections.includes(item.path)) {
                            this.navigateToTabSection(`/dashboard/${item.path}`);
                          } else {
                            history.push(`/dashboard/${item.path}`);
                          }
                        }
                      }}>
                      <VerticalMenuItemIcon className="material-icons" active={isTabActive}>
                        {item.iconClass}
                      </VerticalMenuItemIcon>
                      <VerticalMenuItemTitle className="hidden-xs">
                        <span>{item.label}</span>
                        {!this.hasAccessToFeature(item) && <span className="pro-user">PLUS</span>}
                      </VerticalMenuItemTitle>
                    </VerticalMenuItem>
                  </div>
                </div>
              );
            })}
          </VerticalMenu>
          <MainContent className="col-lg-10 col-md-9 col-sm-9 col-xs-10">
            <div className="content-wrapper xs-no-padding">
              {!isEmpty(currentTab) && (
                <currentTab.Component
                  {...this.props}
                  userInfo={userInfo}
                  history={history}
                  id={match.params.id}
                  {...extraparams}
                />
              )}
            </div>
          </MainContent>
          <QuestionIcon>
            <a href="https://support.mysoundwise.com/" target="_blank" title="Support Soundwise">
              <img
                alt="Support Soundwise"
                width={60}
                height={60}
                src="../../images/question-icon.png"
              />
            </a>
          </QuestionIcon>
        </DashboardSection>
      </FullContentWrapper>
    );
  }
}

const QuestionIcon = styled.div`
  position: fixed;
  bottom: 2%;
  right: 2%;
  cursor: pointer;
`;

const DashboardSection = styled(FullContentSection)`
  background-color: #f5f5f5;
`;

const MainContent = styled.div`
  .content-wrapper {
    padding: 20px 5px;
    height: 100%;
  }
`;

const VerticalMenu = styled.div`
  background-color: #ffffff;
  max-width: 270px;
`;

const VerticalMenuItem = styled.div`
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 25px;

  ${props =>
    props.active
      ? `
    color: #f76b1c;
    border-left: 4px solid rgb(247, 107, 28);
  `
      : ''}
`;

const VerticalMenuItemIcon = styled.i`
  font-size: 20px;
  color: ${props => (props.active ? '#f76b1c' : '#687178')};
  margin-right: 5px;
  width: 25px;
  cursor: pointer;
`;

const VerticalMenuItemTitle = styled.div`
  cursor: pointer;

  .pro-user {
    font-size: 10px;
    font-weight: 800;
    color: red;
    margin-left: 5px;
  }
`;

const mapStateToProps = state => {
  const { managed, user, publisherCategories } = state;
  const { userInfo, isLoggedIn } = user;
  return {
    userInfo,
    managed,
    isLoggedIn,
    categories: publisherCategories,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindPromiseCreators(
      {
        fetchManagedSoundcastEpisodesCreator,
        updateSoundcastEpisodesOrderCreator,
        deleteManagedSoundcastEpisodesCreator,
        bulkActionEpisodesCreator,
        fetchPublisherPlanUsageCreator,
        updateManagedSoundcastsOrderCreator,
        updateManagedBundlesOrderCreator,
        updateManagedBundleSouncastsOrderCreator,
        fetchManagedSoundcastsOrderCreator,
        fetchManagedBundlesOrderCreator,
        fetchManagedBundleSoundcastsOrderCreator,
        updateTagAsFeaturedCreator,
        clearTagAsFeaturedCreator
      },
      dispatch
    ),
    ...bindActionCreators(
      {
        addUpdateManagedSoundcastEpisode,
        increasePlanCurrentUsage,
        decreasePlanCurrentUsage,
        removeSoundcastPendingInvites,
        fetchCategories,
        createPublisherCategory,
        updateSoundcastsPublisherCategory,
        updatePublisherCategoryOrder,
        deletePublisherCategory,
        updateSoundcastsCategoryTitle
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
